
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.227 10.406V9.234l5.312-3.836-5.312-3.835V.39l6.359 4.46v1.094l-6.36 4.461zm-5.563 0V9.234l5.313-3.836L.664 1.563V.39l6.36 4.46v1.094l-6.36 4.461z","fill":"currentColor"}})])
          )
        }
      }
    